// filepath: resources/assets/front/js/components/smooth-scroll.js

export function initSmoothScrolling(element = document) {
  element.querySelectorAll('a[href^="#"]:not([data-smooth-scroll-init])').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      
      // Ignorer les liens vides (#) ou utilisés pour d'autres comportements
      if (href === '#' || href === '#!') {
        return;
      }
      
      e.preventDefault();
      const target = document.querySelector(href);
      
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        
        // Mettre à jour l'URL sans recharger la page
        if (history.pushState) {
          history.pushState(null, null, href);
        }
      }
    });
    
    anchor.setAttribute('data-smooth-scroll-init', 'true');
  });
  
  if (element === document) {
    console.log('🔗 Smooth scrolling initialized');
  }
}